module.exports = __webpack_public_path__ + "static/media/RobTemple.de594534.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/2019-speakers/RobTemple.png
// module id = 848
// module chunks = 0